export const base_path ='/'
export const img_path ='/'
export const API_URL = process.env.REACT_APP_API_URL
export const DEFAULT_TENANT = process.env.REACT_APP_DEFAULT_TENANT